import { Position } from 'geojson';
import { StrapiError } from '@dh/types';

export interface TimeStampAttributes {
    createdAt: Date;
    updatedAt: Date;
    publishedAt: Date | null;
}

export interface Localized {
    de: string;
}

export type MapBoxAddress = {
    fullAddress: string;
    coordinates: Position;
};

export enum SyncState {
    New = 'new',
    Edited = 'edited',
    Deleted = 'deleted',
    Synced = 'synced'
}

export type MediaFileEnding = 'svg' | 'png';

export type DeleteResult = { success: true } | { success: false; error: Error };
export type UpdateResult = { success: true } | { success: false; error: StrapiError };

export type MediaAttributes = {
    name: `${string}.${MediaFileEnding}`;
    alternativeText: string;
    caption: null | string;
    width: number;
    height: number;
    formats: null;
    hash: string;
    ext: MediaFileEnding;
    mime: `image.${MediaFileEnding}`;
    size: number;
    url: string;
    previewUrl: null | URL;
    provider: string;
    provider_metadata: null;
    createdAt: string;
    updatedAt: string;
};
